module.exports = __webpack_public_path__ + "img/COP.b08936bd.svg";